import React from "react";
import { addictionCardTagLineBoldDesktop,addictionCardTagLineBoldMobile,addictionCardTagLineNormalDesktop,addictionCardTagLineNormalMobile,
    addictionCardTextBoldDesktop,addictionCardTextBoldMobile,addictionCardTextNormalDesktop,addictionCardTextNormalMobile
    ,moneyContainerHeadingBoldDesktop,moneyContainerHeadingBoldMobile,
    penaltyTextDesktop,penaltyTextMobile,smallestFontDesktop,smallestFontMobile,
    tinyFontMobile
} from "./Fonts";

const ContentWithLineLimit = ({ bgColor, fontColor, Fontsref, content,lineLimit }) => {
    const limitToTwoLines = {
        display: "-webkit-box",
        WebkitLineClamp: lineLimit,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        background:bgColor,
    };

    // Mapping size property to the corresponding style function
    const styleMapping = {
        "addiction-card-tagline-bold-desktop": addictionCardTagLineBoldDesktop,
        "addiction-card-tagline-bold-mobile": addictionCardTagLineBoldMobile,
        "addiction-card-tagline-normal-desktop": addictionCardTagLineNormalDesktop,
        "addiction-card-tagline-normal-mobile": addictionCardTagLineNormalMobile,
        "addiction-card-text-bold-desktop": addictionCardTextBoldDesktop,
        "addiction-card-text-bold-mobile": addictionCardTextBoldMobile,
        "addiction-card-text-normal-desktop": addictionCardTextNormalDesktop,
        "addiction-card-text-normal-mobile": addictionCardTextNormalMobile,
        "moneycontainer-heading-bold-mobile":moneyContainerHeadingBoldMobile,
        "moneycontainer-heading-bold-desktop":moneyContainerHeadingBoldDesktop,
        "penalty-text-desktop":penaltyTextDesktop,
        "penalty-text-mobile":penaltyTextMobile,
        "smallest-font-desktop":smallestFontDesktop,
        "smallest-font-mobile":smallestFontMobile,
        "tiny-font-mobile":tinyFontMobile
    };

    // Retrieve the appropriate style function based on the size property
    const getStyle = styleMapping[Fontsref] || (() => ({})); // Fallback to an empty function if size is invalid

    return (
        <div id="content-with-line-limit" style={limitToTwoLines}>
            <p style={getStyle({ bgColor, fontColor })}>
                {content}
            </p>
        </div>
    );
};

export default ContentWithLineLimit;
